import { assets } from 'pro/config/assets'
import { IShareChannel } from '@base/lib/share/interface'

export const SHARE_CHANNELS_CONFIG: IShareChannel[] = [
    {
        channel: 'other',
        utmSource: 'unknown',
    }, {
        channel: 'facebook',
        utmSource: 'facebook',
        imageUrl: assets.sns.facebook,
        track: 'Facebook',
        text: 'Facebook',
        langCode: 'web_common_share_facebook_title',
    }, {
        channel: 'x',
        utmSource: 'x',
        imageUrl: assets.sns.x,
        track: 'X',
        text: 'X',
        langCode: '',
    }, {
        channel: 'whatsapp',
        utmSource: 'whatsapp',
        imageUrl: assets.sns.whatsApp,
        track: 'WhatsApp',
        text: 'WhatsApp',
        langCode: '',
    }
]